<template>
    <div class="update-plan">
        <cart-nav :options="[ $t('cart_nav.choose_plan'), $t('cart_nav.confirm_details'), $t('cart_nav.complete') ]" :active="cartIndex"></cart-nav>
        <div :class="['content', {'reo-processing': processing}]" v-if="hasSub">
            <div class="content-wrap js-content-wrap">
                <h1 v-if="config.platform === 'web'">{{ title }}</h1>
                <h3>{{ $t('update_plan.sub_title') }}</h3>
                <plan-message :list="message" class="plan-message"></plan-message>
                <h3 v-html="$t('update_plan.switch_title')" class="switch-title"></h3>
                <p class="notice-for-free"
                    v-html="planNoticeText"
                    v-if="cloudConfig.planNotice && cloudConfig.planNotice.show">
                </p>
                <countrySelectSpinner v-if="!FEATURE('cloud.country_select')" @countrySelect="selectedCountry=$event"></countrySelectSpinner>
                <productSelectSpinner @productSelect="selectedProduct=$event"></productSelectSpinner>
                <plan-item
                v-for="(plan, index) in planList"
                :key="index"
                :plan="plan"
                :selectedId="planId"
                :currentPlan="currentPlan"
                :disabledPlan="disabledPlan"
                :activeItem="activeItem"
                :index="index"
                @changeActive="changeActive"
                @selectProduct="selectProduct"></plan-item>
                <p class="button-group">
                    <button
                    ga-label="Switch continue"
                    class="ui-button primary-button"
                    @click="switchPlan">{{ $t('update_plan.confirm_button') }}</button>
                    <router-link
                    ga-label="Switch cancel"
                    class="ui-button empty-button"
                    to="/user/dashboard/"
                    v-if="config.platform === 'web'">{{ $t('update_plan.cancel_button') }}</router-link>
                </p>
            </div>
        </div>
        <reo-dialog
        v-if="showSubDialog"
        class="video-quantity-confirm-dialog"
        :title="$t('videoQuantityConfirm.title')"
        :labelOfConfirm="$t('videoQuantityConfirm.confirm')"
        :labelOfCancel="$t('videoQuantityConfirm.cancel')"
        @confirm="goCheckout"
        @cancel="showSubDialog = false">
            <div slot="top">
                <video-quantity-confirm
                :current-quantity="currentVideoQuantity"
                :plan-quantity="planVideoQuantity"
                :plan-title="planTitle"></video-quantity-confirm>
            </div>
        </reo-dialog>
    </div>
</template>

<script>
import planMessage from '@/components/planMessage';
import countrySelectSpinner from '@/components/countrySelectSpinner';
import productSelectSpinner from '@/components/productSelectSpinner';
import { getProducts, previewSubscriptions } from '@/api/cart';
import { orderedProductInfo, freePlanRenewable, getActivityPlanId } from '@/api/plan';
import PlanItem from '@/view/cloud/PlanItem';
import { unfoldError } from '@/common/js/notice';
import ReoCheckbox from '@/basic/Checkbox';
import { config } from 'CONFIG';
import router from '@/router';
import cartNav from '@/components/cartNav';
import { subscription as subscriptionStatus, plan as planStatus } from '@/config/status';
import ReoDialog from '@/basic/Dialog';
import { getDeviceList } from '@/api/cloud';
import videoQuantityConfirm from '@/components/videoQuantityConfirm';
import { getCloudConfig } from '@/api/s3Config';
import store from '@/store';
import reolinkGa from '@/common/js/gtagPageview';

export default {

    components: {

        planMessage,
        PlanItem,
        ReoCheckbox,
        cartNav,
        ReoDialog,
        videoQuantityConfirm,
        countrySelectSpinner,
        productSelectSpinner

    },

    data () {

        return {

            planList: [],
            refund: [],
            planId: 0,
            config,
            cartIndex: 0,
            switchable: false,
            hasSub: false,
            sub: {},
            disabledPlan: [],
            processing: false,
            activeItem: 100,
            planVideoQuantity: 0,
            showSubDialog: false,
            currentVideoQuantity: 0,
            planTitle: '',
            cloudConfig: {},
            selectedCountry: '',
            selectedProduct: []

        };

    },
    async created () {

        await this.getProducts();
        this.init();
        let cloudConfig = await getCloudConfig();
        this.cloudConfig = cloudConfig;

    },
    methods: {

        async getProducts () {

            try {

                let activityPlanId = await getActivityPlanId();
                let planList = await getProducts({ classify: true, activityPlanId: activityPlanId });
                this.planList = planList;

            } catch ( err ) {

                console.error( err );
                unfoldError( 'errors.server_error' );

            }

        },
        async selectProduct ( plan ) {

            this.planId = plan.id;
            this.planVideoQuantity = plan.metadata['cloud_storage.max_device_quantity'];
            this.planTitle = plan.title;
            let sub = this.sub;
            let price = Number( plan.cycle.standard.salePrice );
            /**
             * 收费套餐切换至免费套餐时预览退款金额
             *
             * 否则不显示退款金额
             */
            if ( sub && sub.status === subscriptionStatus.ACTIVE && Number( sub.plan.cycle.standard.salePrice ) > 0 && price === 0 ) {

                this.processing = true;
                let sub = await previewSubscriptions( plan.id, 1 );
                if ( sub.refund.refund ) {

                    this.refund = sub.refund.refund;

                } else {

                    this.refund = [];

                }
                this.processing = false;

            } else if ( this.refund.length > 0 ) {

                this.refund = [];

            }

        },
        async init () {

            try {

                let sub = await orderedProductInfo();
                if ( !sub ) {

                    unfoldError( 'errors.no_plan_to_switch' );
                    return false;

                }
                this.sub = sub;

                // 统计当前事件
                reolinkGa.sendEvent( 'switch', sub.plan.id );

                /**
                 * 当nextSwitchableAt === 0 或者 当前时间小于nextSwitchableAt时间戳时，允许切换
                 */
                if ( sub.nextSwitchableAt === 0 || new Date().getTime() > sub.nextSwitchableAt ) {

                    this.switchable = true;

                } else {

                    // unfoldError( 'errors.frequent_switching' );
                    this.switchable = false;

                }

                /**
                 * 切换套餐页面：
                 *
                 * 当用户当前套餐为免费套餐时，
                 *
                 * 检查是否能够在此页面选择当前套餐进行续费
                 */

                if ( Number( sub.plan.cycle.standard.salePrice ) === 0 && !freePlanRenewable( sub )) {

                    this.disabledPlan.push( sub.plan.id );

                }

                let planList = this.planList;
                for ( let series of planList ) {

                    for ( let plan of series.products ) {

                        if ( this.$store.state.user.showBeta || ( plan.id !== sub.plan.id && !this.switchable ) || plan.status !== planStatus.ENABLED ) {

                            this.disabledPlan.push( plan.id );

                        }

                    }

                }

                /**
                 * 默认选中套餐   query.plan_id || 当前订阅的套餐id (无效套餐的关联套餐)
                 *
                 * 检查默认选中套餐是否可购买且有效
                 *
                 * 否则没有默认选中
                 */

                let planId = Number( this.$route.query.plan_id ) || sub.plan.id;
                let portablePlanId = sub.plan.portablePlan;
                if ( planId && !( this.disabledPlan.includes( planId ) && !sub.plan.portablePlan )) {

                    let breakable = false;

                    for ( let series of this.planList ) {

                        if ( breakable ) break;
                        for ( let plan of series.products ) {

                            if ( plan.id === planId || plan.id === portablePlanId ) {

                                await this.selectProduct( plan );
                                breakable = true;
                                break;

                            }

                        }

                    }

                }

                this.hasSub = true;

            } catch ( err ) {

                /**
                 * 当前没有订阅，或者获取订阅信息失败的时候
                 *
                 * 不允许切换
                 */

                console.error( err );
                unfoldError( 'errors.server_error' );

            }

        },

        async switchPlan () {

            if (( !this.FEATURE( 'cloud.country_select' ) && !this.selectedCountry ) || !this.selectedProduct.length ) {

                unfoldError( 'errors.field_required' );
                window.scrollTo( 0, $( '.js-content-wrap' ).offset().top );
                return;

            }

            if ( !this.planId ) {

                unfoldError( 'errors.no_plan_selected' );

            } else if ( !this.switchable && this.planId !== this.sub.plan.id ) {

                unfoldError( 'errors.frequent_switching' );

            } else {

                let userDevice = await getDeviceList();
                let userDeviceQuantity = userDevice.filter( device => device.status === 'associated' ).length;
                if ( userDeviceQuantity > this.planVideoQuantity ) {

                    this.currentVideoQuantity = userDeviceQuantity;
                    this.showSubDialog = true;

                } else {

                    this.goCheckout();

                }

            }

        },
        goCheckout () {

            router.push({

                path: '/checkout/',
                query: {

                    plan_id: this.planId

                }

            });

        },
        changeActive ( index ) {

            this.activeItem = index;

        }

    },
    computed: {

        message () {

            let {sub, refund} = this;
            let account;
            if ( this.FEATURE( 'cloud.email_check' )) {

                account = '+' + this.$store.state.user.user.mobilePhone.number;
            
            } else {

                account = this.$store.state.user.user.email.address;
            
            }
            let result = [
                {
                    label: this.$t( 'update_plan.account_label' ),
                    texts: [
                        account
                    ],
                    red: true
                },
                {
                    label: this.$t( 'update_plan.plan_label' ),
                    texts: [
                        this.$options.filters.planName( sub.plan )
                    ],
                    red: true
                }
            ];
            if ( refund && refund.length > 0 ) {

                let refundText = refund.map(( item ) => {

                    return `${this.$t( `CURRENCY.${item.currency}` )} ${item.value}`;

                }).join( ' + ' );
                result.push({

                    label: this.$t( 'update_plan.refund_label' ),
                    texts: [
                        refundText
                    ]

                });

            }
            return result;

        },
        title () {

            if ( this.sub ) {

                let planTitle = this.sub.plan.title;
                return this.$t( 'update_plan.title', {

                    plan: planTitle

                });

            }
            return '';

        },
        currentPlan () {

            let sub = this.sub;
            return sub.status === subscriptionStatus.ACTIVE ? sub.plan.id : 0;

        },
        planNoticeText () {

            if ( !this.cloudConfig.planNotice || !this.cloudConfig.planNotice.show || !this.cloudConfig.planNotice.text ) {

                return '';

            } else {

                let lang = store.state.lang.lang;
                return this.cloudConfig.planNotice.text[lang] || '';

            }

        }

    }

};
</script>

<style scoped lang="less">
.update-plan{
    background-color: #f3f4f9;
    padding: 0.6rem 0;
    @media @mobile{
        background-color: #fff;
        padding: 0;
    }
}
h1{
    font-weight: 700;
    font-size: 0.36rem;
    margin-bottom: 0.4rem;
    text-align: center;
    @media @mobile{
        font-size: 0.64rem;
        font-weight: 500;
        margin-bottom: 0.6rem;
    }
}
.content{
    max-width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    padding: 0.6rem 0 0.7rem;
    border-radius: 0.24rem;
    @media @mobile{
        padding: 1rem 15px;
    }
    .content-wrap{
        max-width: 760px;
        margin: 0 auto;
    }
}
h3{
    font-weight: 700;
    font-size: 0.2rem;
    margin-bottom: 0.2rem;
    @media @mobile{
        font-size: 0.36rem;
        margin-bottom: 0.3rem;
    }
    &.switch-title {
        margin-bottom: 0.15rem;
        @media @mobile{
            margin-bottom: 0.24rem;
        }
    }
}
.plan-message{
    margin-bottom: 0.5rem;
}
.plan-statement{
    padding-left: 0.4rem;
    position: relative;
    margin-bottom: 0.7rem;
    @media @mobile{
        padding-left: calc(22px + 0.2rem);
        margin: 0.44rem 0 0.88rem;
    }
}
.plan-statement-check{
    position: absolute;
    top: 0;
    left: 0;
}
.button-group{
    text-align: center;
    .ui-button+.ui-button{
        margin-left: 0.4rem;
    }
    @media @mobile{
        margin-top: 0.6rem;
        .ui-button{
            width: 100%;
            box-sizing: border-box;
        }
        .ui-button+.ui-button{
            margin: 0.2rem 0 0;
        }
    }
}
</style>

<style lang="less">
.plan-statement a{
    color: @theme;
    font-weight: 500;
}
.plan-statement a:hover{
    text-decoration: underline;
}
.update-plan h3 span{
    font-weight: 400;
    font-size: 0.16rem;
    @media @mobile{
        font-size: 0.24rem;
    }
}
.update-plan .notice-for-free{
    margin: 0 0 .22rem;
    font-size: .16rem;
    font-weight: 500;
    color: #E74330;
    .title,
    .des{
        font-size: 0.16rem;
    }
    @media @mobile{
        font-size: 0.26rem;
        margin: .2rem 0 .25rem;
        .title,
        .des{
            font-size: 0.26rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/updatePlan/index.vue